import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router'
import Head from 'next/head';

import { MagazineMenuData } from '../../../public/MenuData';

import Pan1HNBADV from '../../layout/pan1HNBADV';
import Pan2HNBTools from '../../layout/pan2HNBTools';
import Pan3Menu from '../../layout/pan3MagazineMenu';
import Pan3MobileMenu from '../../layout/pan3MagazineMobileMenu';
import Pan4ADV from '../../layout/pan4ADV';

import WeeklyBest from '../p5WeeklyBest';
import ArticleList from './p6ArticleList';

import Pan8Footer from '../../layout/pan8Footer/magazine';

import CustomTitle from '../../common/custom-title';

export default props=>{
    // if (!props.me) return <></>;
    let router = useRouter();
    let query = router.query;
    // let vKW = router.query.kw;

    const [vKW, setKW] = useState(null);

    useEffect(() => {
        if (router.asPath == router.pathname) {
            setKW("전체");
        } else if (Object.keys(router.query).length > 0) {
            setKW(router.query.kw);
        } else {
            ;
        }

        console.log(": ", Object.keys(router.query).length, router.asPath, router.pathname);
        // if (typeof kw == 'undefined') kw="전체";
        if ( router.asPath == router.pathname) setKW("전체");
        if (Object.keys(router.query).length == 0) return;

        else setKW(router.query.kw);
        return () => { ; };
    }, [router.query]);


    
    const [isMM, setMenu] = useState('block');// 모바일 메뉴 div의 display 속성

    return (<div className="">
        <CustomTitle subject="" />
        <Head>

            <meta property="og:title" content="캠스콘 CAMSCON" />
            <meta name="og:title" content="캠스콘 CAMSCON" />
            <meta property="og:description" content="캠스콘은 서울을 기반으로 하는 디지털 패션매거진이자 커뮤니티입니다. 스트리트 패션과 서브컬처, 스니커즈 관련 콘텐츠를 만나보세요." />
            <meta name="og:description" content="캠스콘은 서울을 기반으로 하는 디지털 패션매거진이자 커뮤니티입니다. 스트리트 패션과 서브컬처, 스니커즈 관련 콘텐츠를 만나보세요." />
            <meta property="og:image" content="/fb_og.jpg" />
            <meta name="og:image" content="/fb_og.jpg" />
            <meta property="title" content="캠스콘 CAMSCON" />
            <meta name="title" content="캠스콘 CAMSCON" />
            <meta property="description" content="캠스콘은 서울을 기반으로 하는 디지털 패션매거진이자 커뮤니티입니다. 스트리트 패션과 서브컬처, 스니커즈 관련 콘텐츠를 만나보세요." />
            <meta name="description" content="캠스콘은 서울을 기반으로 하는 디지털 패션매거진이자 커뮤니티입니다. 스트리트 패션과 서브컬처, 스니커즈 관련 콘텐츠를 만나보세요." />
            <meta property="url" content="https://camscon.kr" />
            <meta name="url" content="https://camscon.kr" />
            <meta property="author" content="캠스콘 CAMSCON" />
            <meta name="author" content="캠스콘 CAMSCON" />
            <meta property="keywords" content="스트리트 패션, 서브컬처, 스니커즈" />
            <meta name="keywords" content="스트리트 패션, 서브컬처, 스니커즈" />

        </Head>

        <style jsx>{`

.pan {
    padding-top:40px;
}

@media all and (max-width:606px) {
    .pan{
        padding-top:32px;
    }

    .ctn{
        display:block;
        position: fixed;
        right: 12px;
        bottom: 18px;
    }
}

`}</style>
        <Pan1HNBADV />
        <div className="narrow-content">
            <Pan2HNBTools isMagazine showMenu={() => setMenu('block')} />

            <div className="dbom"><Pan3MobileMenu isMagazine /></div>
            <div className=""><Pan3Menu lookaround isMM={isMM} depart={vKW} hideMobileMenu={() => setMenu('none')} /></div>
            {vKW == '전체' ? <>
                <Pan4ADV />
                <div className="pan pan5"><WeeklyBest /></div>
            </> : null}

            <div className="pan">
                <ArticleList depart={vKW} />
            </div>

        </div>
        <Pan8Footer />
    </div>);
}